import React, { VFC } from 'react';
import { Image, MEDIA_TYPE } from '~/models/Instagram/InstagramModel';
import ImageComponent from './Image';
import Styled from './Styled';

const { A } = Styled;

interface Props {
  size: number;
  image: Image;
}
const ImageLink: VFC<Props> = ({ size, image }: Props) => {
  const imageLink =
    image.mediaType === MEDIA_TYPE.VIDEO ? image.thumbnailUrl : image.mediaUrl;
  return (
    <A key={image.id} href={image.permalink} target="_blank" rel="noreferrer">
      <ImageComponent src={imageLink} alt={image.permalink} size={size} />
    </A>
  );
};

export default ImageLink;
